import Image1 from "../../assets/Furniture Image 1.jpg";
import Image2 from "../../assets/Furniture Image 2.jpg";
import Image3 from "../../assets/Furniture Image 3.jpg";
import Image4 from "../../assets/IMG_1677.jpg";
import Image5 from "../../assets/IMG_1680.jpg";
import Image6 from "../../assets/AquaTable_1.png";
import Image7 from "../../assets/AquaTable_4.jpg";
import Image8 from "../../assets/AquaTable_3.png";
import Image9 from "../../assets/MercuricTables_3.png";
import Image10 from "../../assets/MercuricTables_2.png";
import Image11 from "../../assets/MercuricTables_4.png";
import Image12 from "../../assets/Large House 1.jpg";
import Image15 from "../../assets/Project Dubai.png";
import Image16 from "../../assets/IMG_1683.jpg";
import Image17 from "../../assets/Large House 2.jpg";
import Image18 from "../../assets/Women in black.jpg";
import Image19 from "../../assets/Large House 3.jpg";
import Image20 from "../../assets/Victorian House.png";
import Image21 from "../../assets/luxury-villa-.png";
import Image22 from "../../assets/luxe-villa-3.png";
import Image23 from "../../assets/luxe-villa-1.png";
import Image24 from "../../assets/elan3.png";
import Image25 from "../../assets/elan5.png";
import Image26 from "../../assets/elan-1.png";
import Image27 from "../../assets/elan2.png";
import Image28 from "../../assets/elan4_1.png";
import Image29 from "../../assets/elan6-ezgif.com-webp-to-png-converter.png";
import Image30 from "../../assets/es1-ezgif.com-webp-to-png-converter.png";
import Image31 from "../../assets/Blue House Image.jpeg";
import "./ImagesContainer.css";

const ImagesContainer = () => {
  return (
    <section id="home">
      <div className="large-image-container">
        <img
          className="large-image"
          src="https://storage.googleapis.com/free-templates/summer-24/images/IMAGES%20EDITO/EDITO_01.jpg"
          alt="Large"
        />
      </div>

      <div className="three-images-container">
        <div className="image-column">
          <img src={Image1} alt="1" />
        </div>
        <div className="image-column">
          <img src={Image2} alt=" 2" />
        </div>
        <div className="image-column">
          <img src={Image3} alt="3" />
        </div>
      </div>

      <div className="large-image-container-left">
        <img className="large-image-left" src={Image4} alt="4" />
      </div>

      <div className="large-image-container-right">
        <img className="large-image-right" src={Image5} alt="5" />
      </div>

      <div className="three-images-container">
        <div className="image-column">
          <img src={Image6} alt="1" />
        </div>
        <div className="image-column">
          <img src={Image7} alt=" 2" />
        </div>
        <div className="image-column">
          <img src={Image8} alt="3" />
        </div>
      </div>

      <div
        className="three-images-container"
        style={{ marginTop: 0, paddingTop: 0 }}
      >
        <div className="image-column">
          <img src={Image9} alt="1" />
        </div>
        <div className="image-column">
          <img src={Image10} alt=" 2" />
        </div>
        <div className="image-column">
          <img src={Image11} alt="3" />
        </div>
      </div>

      <div className="large-image-container">
        <img className="large-image" src={Image12} alt="Large" />
        <a className="textUnderImage" href="/">
          INTRODUCING "THE CASE" RESIDENCES IN DELHI NCR
        </a>
      </div>

      <div className="large-image-container-left">
        <img className="large-image-left" src={Image15} alt="4" />
      </div>

      <div className="large-image-container-right">
        <img className="large-image-right" src={Image16} alt="5" />
      </div>

      <div className="large-image-container">
        <img className="large-image" src={Image17} alt="Large" />
      </div>

      <div className="large-image-container-left">
        <img className="large-image-left" src={Image18} alt="4" />
      </div>

      <div className="large-image-container-right">
        <img className="large-image-right" src={Image19} alt="5" />
      </div>

      <div className="large-image-container">
        <img className="large-image" src={Image20} alt="Large" />
      </div>

      <div className="three-images-container">
        <div className="image-column">
          <img src={Image25} alt="1" />
        </div>
        <div className="image-column">
          <img src={Image23} alt=" 2" />
        </div>
        <div className="image-column">
          <img src={Image31} alt="3" />
        </div>
      </div>

      <div className="large-image-container-left">
        <img className="large-image-left" src={Image21} alt="4" />
      </div>

      <div className="large-image-container-right">
        <img className="large-image-right" src={Image22} alt="5" />
      </div>

      <div className="three-images-container">
        <div className="image-column">
          <img src={Image27} alt="1" />
        </div>
        <div className="image-column">
          <img src={Image24} alt=" 2" />
        </div>
        <div className="image-column">
          <img src={Image26} alt="3" />
        </div>
      </div>

      <div
        className="three-images-container"
        style={{ marginTop: 0, paddingTop: 0 }}
      >
        <div className="image-column">
          <img src={Image28} alt="1" />
        </div>
        <div className="image-column">
          <img src={Image30} alt=" 2" />
        </div>
        <div className="image-column">
          <img src={Image29} alt="3" />
        </div>
      </div>
    </section>
  );
};

export default ImagesContainer;
